import React, {useEffect, useRef, useState} from "react";

import {
  calculateSumOfEachRowSadan,
  deleteRowHandlerSadan, myCustomCelEditFunction, updateTableCellHandlerSadan,
} from "../SellFactorFunctionsSadan";
import tableCalc from "../../../utils/tableCalc";
import NewTabulator from "../../NewTabulator/NewTabulator";
import {parseToEnRemoveComma} from "../../../utils/CommaSeparator";

import utilsFunction from "../../../utils/utilsFunction";
import numeric from "../../../utils/NumericFunction";

const FactorTableJozNEWSadan = ({
                                  sendData,
                                  setSendData,
                                  initialData,
                                  componentData,
                                  setComponentData,
                                }) => {
  console.log("FactorTableJoz Just Rendered");

  // const tableRef = useRef();
  const tableOptions = {
    layout: "fitDataStretch",
    selectable: 1,
    index: "na_31",
  };
  // recordId: "",
  //   productId: "1",
  //   productName: "productName",
  //   productGroup: "productGroup",
  //   productSize: "productSize",
  //   productColor: "productColor",
  //   price: 200,
  //   number: "number",
  //   discount: "discount",
  //   storeId: 2
  const tableColumns = [
    {
      title: "حذف",
      headerSort: false,
      formatter: "buttonCross", // width: 60,
      style: {
        width: 200,
        overflow: 'hidden',
        textAlign: 'center',
        display: 'flex',
        alignItem: 'center',
        justifyContent: 'center',
      },
      justifyContent: 'center',
      headerHozAlign: "center",
      cellClick: function (e, cell) {
        console.log("حذف حذف حذف");
        const productId = cell.getData().productId;
        const storeId = cell.getData().storeId;
        const type = cell.getData().type;
        const tableData = deleteRowHandlerSadan(
          sendData.tableData,
          productId,
          storeId,
          type,
        );
        setSendData({tableData});
      },
    },
    {
      field: "recordId",
      visible: false,
    },
    {
      title: "کد انبار",
      field: "storeId",
      visible: true,
      style: {
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },
    {
      title: "نام انبار",
      field: "storeName",
      visible: false,
      style: {
        minWidth: 80,
        width: 80,
        maxWidth: 80,
        textAlign: 'center',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },
    {
      title: "کد کالا",
      visible: false,

      field: "productId",
      style: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },
    {
      title: "نام کالا",
      field: "productName",
      style: {
        minWidth: 200,
        width: 200,
        maxWidth: 200,
        overflow: 'hidden',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },
    {
      title: "گروه کالا",
      field: "productGroup",
      visible: false,
      style: {
        overflow: 'hidden',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },
    {
      title: "کد گروه کالا",
      field: "productGroupId",
      visible: false,
      style: {
        overflow: 'hidden',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },
    {
      title: "تعداد",
      field: "number",
      visible: true,
      style: {
        overflow: 'hidden',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },
    {
      title: "نوع",
      field: "type",
      visible: false,
      style: {
        overflow: 'hidden',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },
    {
      title: "نوع",
      field: "typeShow",
      visible: true,
      style: {
        overflow: 'hidden',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },
    {
      title: "وزن",
      field: "weight",
      editor: "number",
      // formatter: tableCalc.persianDigits,
      style: {
        padding: 5,
        minWidth: 120,
        width: 120,
        maxWidth: 120,
        overflow: 'hidden',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },


      cellEdited: function (e, cell) {

        let value = (e.target.value);
        const type=cell.getData().type;
        // if(type==='pack'){
        //   console.log('در فاکتور فروش در حالت بسته وزن نمیتونه تغییر کنه')
        //   return
        // }


        value = utilsFunction.LimitDotAndThreeCharsAfterDot(value)

        // مقدار منحصر به فرد هر سطر داره بر اساس ترکیب انبار و کدمحصول گرفته میشه
        myCustomCelEditFunction(sendData, setSendData, cell, "weight", value)
        setReload(!reload)


      },

      editorParams: {
        min: 1,
        step: 1,
      },
      bottomCalc: tableCalc.sum,
      formatter: tableCalc.persianNumberFormatter,
    },
    {
      title: "قیمت",
      field: "price",
      editor: "number",
      editorParams: {
        min: 1,
        step: 1,
      },
      style: {
        minWidth: 120,
        maxWidth: 120,
        overflow: 'hidden',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
      formatter: tableCalc.separateNumbers, // topCalc : tableCalc.sum,
      cellEdited: function (e, cell) {
        const type=cell.getData().type;
        if(type==='pack'){
          console.log('در فاکتور فروش قیمت بسته نمیتونه تغییر کنه')
          return
        }

        let value = parseToEnRemoveComma(e.target.value);
        if (value === '') {
          value = 0
        }

        myCustomCelEditFunction(sendData, setSendData, cell, "price", value);
        setReload(!reload)

      },
    },
    {
      title: "تخفیف",
      field: "discount",
      editor: "number",
      editorParams: {
        min: 0,
        step: 1,
      },
      style: {
        overflow: 'hidden',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
      bottomCalc: tableCalc.sum,
      formatter: tableCalc.separateNumbers,
      cellEdited: function (e, cell) {
        let value = parseToEnRemoveComma(e.target.value);
        if (value === '') {
          value = 0
        }
        myCustomCelEditFunction(sendData, setSendData, cell, "discount", value)
        setReload(!reload)

      },
    },
    {
      title: "جمع کل",
      field: "total", // bottomCalc: "sum",
      bottomCalc: tableCalc.sum,
      hozAlign: "center", // minWidth: 250,
      style: {
        minWidth: 100,
        width: 100,
        maxWidth: 150,
        overflow: 'hidden',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },
  ];


  // دفعه توی حالت ادیت جدول آپدیت نمیشد مگه اینکه  اطلاعات سنددیتا تغییر میکرد. منم اینجا اینو گذاشتم تا کار کنه
  const [reload, setReload] = useState(false)


  useEffect(() => {
    setSendData({tableData: calculateSumOfEachRowSadan(sendData.tableData)});

  }, [reload])

  return (
    <div>
      {
        <div>
          <div className="serachbox__">

          </div>
          <NewTabulator
            columns={tableColumns}
            // data={dataEdit.main !== undefined ? dataEdit.particle.data : [] }
            data={sendData.tableData}
            options={tableOptions}
            // options={TabulatorTableOptions.style3}
            style={{height: "50vh", overflowY: 'scroll'}}
            className={"header__color__F1F1F1"}

          />
        </div>
      }
      {
        /*
                <ReactTabulator
                  ref={tableRef}
                  columns={tableColumns}
                  // data={dataEdit.main !== undefined ? dataEdit.particle.data : [] }
                  data={sendData.tableData}
                  options={tableOptions}
                  // options={TabulatorTableOptions.style3}
                  style={{height: "70vh"}}
                />
        */
      }

    </div>
  );
};

export default FactorTableJozNEWSadan;
